(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({ note: event.target.value });
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rimthin-b2b-landing"] && !Shopify.designMode) return;
  try {
    
  if (!window.rimthinSamePageScrollReady) {
    window.rimthinSamePageScrollReady = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rsh-scroll-target]');
      var targetId;
      var target;
      var header;
      var headerHeight;
      var targetTop;
      var maxScroll;
      var extraSpace;
      var spacer;

      if (!button) return;

      targetId = button.getAttribute('data-rsh-scroll-target');
      target = document.getElementById(targetId);
      if (!target) {
        document.querySelectorAll('[data-section-id], [id]').forEach(function (element) {
          if (target) return;
          if (element.getAttribute('data-section-id') === targetId || element.id.endsWith('__' + targetId)) target = element;
        });
      }
      if (!target) return;

      header = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header, header');
      headerHeight = header ? header.getBoundingClientRect().height : 0;
      targetTop = window.scrollY + target.getBoundingClientRect().top - headerHeight - 24;
      event.preventDefault();
      maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      extraSpace = targetTop - maxScroll;

      if (extraSpace > 0) {
        spacer = document.getElementById('rimthin-same-page-scroll-spacer');
        if (!spacer) {
          spacer = document.createElement('div');
          spacer.id = 'rimthin-same-page-scroll-spacer';
          spacer.setAttribute('aria-hidden', 'true');
          spacer.style.pointerEvents = 'none';
          document.body.appendChild(spacer);
        }
        spacer.style.height = Math.ceil(extraSpace + 24) + 'px';
      }

      window.requestAnimationFrame(function () {
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rimthin-beam-patterns"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rimthin-beam-patterns')) {
    customElements.define('rimthin-beam-patterns', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
        clearTimeout(this.statusTimer);
        this.events?.abort();
        this.observer?.disconnect();
      }

      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.controls = this.querySelector('[data-controls]');
        this.dots = this.querySelector('[data-dots]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        if (!this.track || !this.cards.length) return;

        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous.addEventListener('click', () => this.go(this.active - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.active + 1), { signal });
        this.dots.addEventListener('click', event => {
          const button = event.target.closest('[data-page]');
          if (button) this.go(Number(button.dataset.page));
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = this.active + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = this.active + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.positions.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.go(target);
        }, { signal });
        this.track.addEventListener('focusin', event => {
          const card = event.target.closest('[data-card]');
          if (card) this.reveal(card, false);
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => this.announce(), 180);
        }, { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (card) this.reveal(card, true);
        }, { signal });

        this.observer = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.measure());
        });
        this.observer.observe(this.track);
        this.cards.forEach(card => this.observer.observe(card));
        this.classList.add('is-ready');
        this.measure();
      }

      offset() {
        return Math.abs(this.track.scrollLeft);
      }

      cardOffset(card) {
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        return this.offset() + (rtl ? trackRect.right - cardRect.right : cardRect.left - trackRect.left);
      }

      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const positions = [0];
        this.cards.forEach(card => {
          const position = Math.max(0, Math.min(this.cardOffset(card), max));
          if (position - positions[positions.length - 1] > 3) positions.push(position);
        });
        if (max - positions[positions.length - 1] > 3) positions.push(max);
        const countChanged = positions.length !== this.positions?.length;
        this.positions = positions;
        if (countChanged) {
          const fragment = document.createDocumentFragment();
          positions.forEach((position, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'bpe__dot';
            button.dataset.page = String(index);
            button.setAttribute('aria-controls', this.track.id);
            button.setAttribute('aria-label', this.dataset.pageLabel.replace('[number]', String(index + 1)));
            fragment.append(button);
          });
          this.dots.replaceChildren(fragment);
        }
        const controlsAvailable = getComputedStyle(this.previous).display !== 'none' || getComputedStyle(this.dots).display !== 'none';
        this.controls.hidden = max < 4 || !controlsAvailable;
        this.track.classList.toggle('bpe__track--native', !controlsAvailable);
        this.update();
      }

      update() {
        const offset = this.offset();
        this.active = this.positions.reduce((best, position, index, values) => Math.abs(position - offset) < Math.abs(values[best] - offset) ? index : best, 0);
        Array.from(this.dots.children).forEach((button, index) => {
          if (index === this.active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        this.previous.setAttribute('aria-disabled', String(this.active === 0));
        this.next.setAttribute('aria-disabled', String(this.active === this.positions.length - 1));
      }

      go(index) {
        const target = Math.max(0, Math.min(index, this.positions.length - 1));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.positions[target] * (rtl ? -1 : 1), behavior: reduced || this.dataset.motion === 'instant' ? 'instant' : 'smooth' });
      }

      reveal(card, always) {
        const offset = this.cardOffset(card);
        const current = this.offset();
        if (!always && offset >= current - 2 && offset + card.offsetWidth <= current + this.track.clientWidth + 2) return;
        const nearest = this.positions.reduce((best, position, index, values) => Math.abs(position - offset) < Math.abs(values[best] - offset) ? index : best, 0);
        this.go(nearest);
      }

      announce() {
        this.status.textContent = this.dataset.statusLabel.replace('[number]', String(this.active + 1)).replace('[total]', String(this.positions.length));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rimthin-image-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      var cards;
      var observer;

      if (!section || section.dataset.rimthinRevealReady === 'true') return;

      cards = section.querySelectorAll('.rimthin-cards__card');
      section.dataset.rimthinRevealReady = 'true';

      if (!cards.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cards.forEach(function (card) { card.classList.add('is-visible'); });
        return;
      }

      section.classList.add('rimthin-cards--motion-ready');
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          cards.forEach(function (card) { observer.observe(card); });
        });
      });
    }

    function initAll(scope) {
      if (scope.matches && scope.matches('.rimthin-cards')) initSection(scope);
      scope.querySelectorAll('.rimthin-cards').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
